globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Websites = appCustomerSpace.Controllers.Websites || {};

appCustomerSpace.Controllers.Websites.LocalSiteProjectsDashboard = (function(superClass) {

  utils.extend(LocalSiteProjectsDashboard, superClass);

  function LocalSiteProjectsDashboard() {
    this.$html = $("body.websites.local.site-projects.dashboard")
    return LocalSiteProjectsDashboard.__super__.constructor.apply(this, arguments);
  }

  $.extend(LocalSiteProjectsDashboard.prototype, {
    init: function(){
      this.fetchAnalyticsStatistics();
      return LocalSiteProjectsDashboard.__super__.init.apply(this, arguments);
    },
    fetchAnalyticsStatistics: function(){
      var _this = this;

      _this.$statisticsContents = _this.$html.find(".dashboard-statistics-contents");
      _this.spinnerOptions = { text: "Chargement des statistiques...", icon_size: '1x', style: { backdrop: { background: "#ffffff" }, spinner: { marginBottom: "0" }}}

      appCustomerSpace.Loader().start({ $container: _this.$statisticsContents, options: _this.spinnerOptions })

      $.get( _this.$statisticsContents.data("ajax-url"), function(response) {
        if(response.response == 1) {
          _this.$statisticsContents.html(response.html);
        } else {
          $.extend(true, _this.spinnerOptions, { text: "Impossible de charger les données", error: { persisted: true } } )
          appCustomerSpace.Loader().error({$container: _this.$statisticsContents, options: _this.spinnerOptions })
        }
      }).fail(function(){
        $.extend(true, _this.spinnerOptions, { text: "Impossible de charger les données", error: { persisted: true } } )
        appCustomerSpace.Loader().error({$container: _this.$statisticsContents, options: _this.spinnerOptions })
      });
    }
  });

  return LocalSiteProjectsDashboard;

})(appCustomerSpace.Controllers.Websites.MainController);
